import React from 'react';
import insurence_brand from '../../../assets/images/home_screen/insurence_brand.png';

function InsuranceSection() {
  return (
    <section className="relative w-full flex items-center justify-center lg:px-4 py-10 md:py-20 bg-[#EBF2FA]">
      <div className="relative w-full max-w-[1200px] px-4 md:px-10 py-8 md:py-10 flex flex-col md:flex-row items-center md:text-left gap-20 ">
        <div className="flex-1 flex flex-col items-start gap-4 sm:gap-6 lg:gap-10 text-lg md:text-xl 2xl:text-2xl text-secondary">
          <h1 className="text-[32px] sm:text-[42px] md:text-[48px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] md:mr-4">
            Insurance we accept
          </h1>
          <p className="text-secondary text-lg">
            We accept Alaska Medicaid, Blue Cross/Blue Shield, Tricare, EBMS,
            Aetna, United Health— all other major insurances. We are an
            in-network provider for Blue Cross/ Blue Shield, Tricare, MODA,
            Alaska Medicaid.
          </p>
          <p className="text-secondary text-lg">
            Raven, IDEA, Mat Su Central, Twingley Bridge and other homeschool
            stipends accepted for our services — contact us today to learn more.
          </p>
          <p className="text-secondary text-lg">
            Verifying a child’s benefits is done as a courtesy and is not a
            guarantee of coverage.
          </p>
          <p className="text-secondary text-lg">
            Co-pays are due at time of services. Deductibles are due the month
            they are billed.
          </p>
        </div>
        <div className=" flex-1 flex">
          <img
            loading="lazy"
            src={insurence_brand}
            alt="insurence_brand"
            className="w-full"
          />
        </div>
      </div>
    </section>
  );
}

export default InsuranceSection;
